import React from 'react';

//Componets
import TextField from '@mui/material/TextField';
import { ExtendedFormik, Form } from '../extended-formik';
import { Button, Select, MenuItem } from '@mui/material';

//Hook & lib
import { useAxios } from '../../hooks/use-axios';
import * as Yup from 'yup';
import { evenTypeUrl } from '../../constants/';

//css
import styled from 'styled-components';

const Root = styled.div`
  margin-top: 2%;
`;

const Label = styled.label`
  display: flex;
  flex: wrap;
  margin-bottom: 1%;
  font-size: 16px;
  font-weight: 600;
`;

const Row = styled.div`
  margin-top: 1%;
`;

const Error = styled.div`
  display: flex;
  flex: wrap;
  margin-bottom: 1%;
  font-size: 16px;
  color: red;
`;

export const CreateEventTypeForm = props => {
  const { handleClose } = props;
  const { post } = useAxios();

  return (
    <Root>
      <ExtendedFormik
        initialValues={{
          name: '',
          status: true,
        }}
        validationSchema={Yup.object({
          name: Yup.string()
            .max(120, 'Debe tener un maximo de 120 characters o menos')
            .min(2, 'Debe ser almenos 2 caracteres')
            .required('Required'),
        })}
        onSubmit={async (values, helpers) => {
          const data = {
            name: values.name,
            status: values.status,
          };
          const res = await post(evenTypeUrl.CREATE_EVENT_TYPE, data);
          // console.log(res);
          if (res) handleClose();
        }}
      >
        {formikProps => {
          const {
            values,
            errors,
            // status,
            handleChange,
            // handleBlur,
            // isSubmmitting,
          } = formikProps;

          return (
            <Form>
              <Row>
                <Label>Nombre</Label>
                <TextField required id='name' label='Required' value={values.name} onChange={handleChange} />
                {errors.name ? <Error>{errors.name}</Error> : null}
              </Row>
              <Row>
                <Label>Status</Label>
                <Select
                  required
                  id='status'
                  name='status'
                  label='Required'
                  value={values.status}
                  onChange={handleChange}
                >
                  <MenuItem value={true}>Activo</MenuItem>
                  <MenuItem value={false}>Inactivo</MenuItem>
                </Select>
                {errors.status ? <Error>{errors.status}</Error> : null}
              </Row>
              <Row>
                <Button type='submit'>Guardar</Button>
              </Row>
            </Form>
          );
        }}
      </ExtendedFormik>
    </Root>
  );
};
